/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIEmployeeAutocompleteSuggestion } from './APIEmployeeAutocompleteSuggestion';
import {
    APIEmployeeAutocompleteSuggestionFromJSON,
    APIEmployeeAutocompleteSuggestionFromJSONTyped,
    APIEmployeeAutocompleteSuggestionToJSON,
} from './APIEmployeeAutocompleteSuggestion';

/**
 * 
 * @export
 * @interface APIEmployeeAutocompleteResponse
 */
export interface APIEmployeeAutocompleteResponse {
    /**
     * 
     * @type {Array<APIEmployeeAutocompleteSuggestion>}
     * @memberof APIEmployeeAutocompleteResponse
     */
    suggestions: Array<APIEmployeeAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APIEmployeeAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APIEmployeeAutocompleteResponse interface.
 */
export function instanceOfAPIEmployeeAutocompleteResponse(value: object): value is APIEmployeeAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APIEmployeeAutocompleteResponseFromJSON(json: any): APIEmployeeAutocompleteResponse {
    return APIEmployeeAutocompleteResponseFromJSONTyped(json, false);
}

export function APIEmployeeAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIEmployeeAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APIEmployeeAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APIEmployeeAutocompleteResponseToJSON(value?: APIEmployeeAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APIEmployeeAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

